import { render, staticRenderFns } from "./wraper.vue?vue&type=template&id=a517425e&scoped=true&"
import script from "./wraper.vue?vue&type=script&lang=js&"
export * from "./wraper.vue?vue&type=script&lang=js&"
import style0 from "./wraper.vue?vue&type=style&index=0&id=a517425e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a517425e",
  null
  
)

export default component.exports